import {
    MAIN_NAV_VISIBILITY,
    SET_PREVIEW_LINKS,
    SET_PREVIEW_VISIBILITY,
    SET_PREVIEW_CONTENT,
    SET_PREVIEW_ANCHOR_POS,
    SET_METANAV_LINKS,
    SET_REDUCED_NAV_VISIBILITY,
} from '../../mutation-types';

export function setNavVisibility({ commit }, { isVisible }) {
    commit(MAIN_NAV_VISIBILITY, { isVisible });
}

export function setPreviewLinks({ commit }, { links }) {
    commit(SET_PREVIEW_LINKS, { links });
}

export function setPreviewVisibility({ commit }, { isVisible }) {
    commit(SET_PREVIEW_VISIBILITY, { isVisible });
}

export function setPreviewContent({ commit }, { component, props }) {
    commit(SET_PREVIEW_CONTENT, { component, props });
}

export function setAnchorPosition({ commit }, { x, y }) {
    commit(SET_PREVIEW_ANCHOR_POS, { x, y });
}

export function setMetanavLinks({ commit }, { links, languages }) {
    commit(SET_METANAV_LINKS, { links, languages });
}

export function setReducedNavVisibility({ commit }, { isVisible }) {
    commit(SET_REDUCED_NAV_VISIBILITY, { isVisible });
}
